export default "__VITE_ASSET__EFUyWrCx__"